import React, { ReactElement } from 'react';
import Children from 'react-children-utilities';
import './Table.scss';


/*
  To see fully working examples check the Table.test.tsx file
*/
interface ITable {
  /**
   * Whether has expandable rows or not.
   * In case it has, the row that triggers the expansion will need a subsequent row that will keep the content to show on expansion 
   * and that needs to be tagged with a class "expansion"
  */
  expandable?: boolean
  className?: string,
  children: ReactElement | Array<ReactElement>
}

interface ITableState {
  [key: string]: any
}

class Table extends React.PureComponent<ITable> {

  state: ITableState = {}

  render() {
    const { expandable = false, className = "" } = this.props;
    let children:any = this.props.children;
    if (expandable && children) {
      /*
      add logic to trigger the expansion of the row to the children 
      */
      let idx = 0;
      children = Children.deepMap(children, (child: any) => {
        if (!child) { return child };
  
        const childClasses = (child.props && child.props.className) || "";

        if (child.type === "tr" && !childClasses.includes("expanded")) {
          //need a block scope variable here to be bound to this block every iteration
          let index = ++idx;
          let clonedElement;

          if (childClasses.includes("not-expandable")) {
            clonedElement = React.cloneElement(child, { className: "not-expandable" })
          } else {
            const originalCallBack = child.props.onClick ? child.props.onClick : () => { };
            clonedElement = React.cloneElement(child, {
              className: `${this.state["rowExpanded" + index] ? "cc-table--expandable__rowExpanded" : ""}`,
              onClick: () => {
                this.setState({ ["rowExpanded" + index]: !this.state["rowExpanded" + index] })
                originalCallBack(child);
              }
            })
          }
          return clonedElement;
        }

        if (child.type === "tr" && childClasses.includes("expanded")) {
          //add transition on expansion
          return React.cloneElement(
            child,
            { className: `${childClasses} expanded--smooth` },
            React.createElement("td", {}, [...child.props.children])
          );
        }
        return child;
      })
    }


    return (
      <table className={`cc-table ${className} ${expandable ? "cc-table--expandable" : ""}`}>
        {children}
      </table >
    )
  }
}

export default Table;